module.exports = __webpack_public_path__ + "static/edit-c577e5f8d0740eb6ca8b2df0aa11c1cf.png";